import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  ref: "newPropertyModalRef",
  id: "kt_modal_new_property",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-950px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_new_property_header"
}
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_8 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_new_property_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_new_property_header",
  "data-kt-scroll-wrappers": "#kt_modal_new_property_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_9 = { class: "row mb-12" }
const _hoisted_10 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_11 = { class: "d-flex col-lg-12 fv-row" }
const _hoisted_12 = { class: "indicator-label" }
const _hoisted_13 = { class: "indicator-progress" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "row mb-5" }
const _hoisted_18 = { class: "col-md-6 fv-row" }
const _hoisted_19 = { class: "d-flex align-items-center fs-5 fw-bold mb-2" }
const _hoisted_20 = { class: "required" }
const _hoisted_21 = { class: "col-lg-12 fv-row" }
const _hoisted_22 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_23 = { class: "fv-help-block" }
const _hoisted_24 = { class: "col-md-6 fv-row" }
const _hoisted_25 = { class: "d-flex align-items-center fs-5 fw-bold mb-2" }
const _hoisted_26 = { class: "required" }
const _hoisted_27 = { class: "col-lg-12 fv-row" }
const _hoisted_28 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_29 = { class: "fv-help-block" }
const _hoisted_30 = { class: "row mb-5" }
const _hoisted_31 = { class: "col-md-6 fv-row" }
const _hoisted_32 = { class: "d-flex align-items-center fs-5 fw-bold mb-2" }
const _hoisted_33 = { class: "col-lg-12 fv-row" }
const _hoisted_34 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_35 = { class: "col-md-6 fv-row" }
const _hoisted_36 = { class: "d-flex align-items-center fs-5 fw-bold mb-2" }
const _hoisted_37 = { class: "col-lg-12 fv-row" }
const _hoisted_38 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_39 = { class: "row mb-5" }
const _hoisted_40 = { class: "col-md-6 fv-row" }
const _hoisted_41 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_42 = { class: "fv-plugins-message-container" }
const _hoisted_43 = { class: "fv-help-block" }
const _hoisted_44 = { class: "col-md-6 fv-row" }
const _hoisted_45 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_46 = { class: "fv-plugins-message-container" }
const _hoisted_47 = { class: "fv-help-block" }
const _hoisted_48 = { class: "col-md-3 fv-row" }
const _hoisted_49 = { class: "required fs-5 fw-bold mb-2" }
const _hoisted_50 = { class: "fv-plugins-message-container" }
const _hoisted_51 = { class: "fv-help-block" }
const _hoisted_52 = { class: "col-md-3 fv-row" }
const _hoisted_53 = { class: "required fs-5 fw-bold mb-2" }
const _hoisted_54 = { class: "fv-plugins-message-container" }
const _hoisted_55 = { class: "fv-help-block" }
const _hoisted_56 = { class: "col-md-6 fv-row" }
const _hoisted_57 = { class: "required fs-5 fw-bold mb-2" }
const _hoisted_58 = { class: "fv-plugins-message-container" }
const _hoisted_59 = { class: "fv-help-block" }
const _hoisted_60 = { class: "row mb-5" }
const _hoisted_61 = { class: "col-md-6 fv-row" }
const _hoisted_62 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_63 = { class: "fv-plugins-message-container" }
const _hoisted_64 = { class: "fv-help-block" }
const _hoisted_65 = { class: "col-md-6 fv-row" }
const _hoisted_66 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_67 = { class: "fv-plugins-message-container" }
const _hoisted_68 = { class: "fv-help-block" }
const _hoisted_69 = { class: "row mb-5" }
const _hoisted_70 = { class: "col-md-6 fv-row" }
const _hoisted_71 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_72 = { class: "fv-plugins-message-container" }
const _hoisted_73 = { class: "fv-help-block" }
const _hoisted_74 = { class: "col-md-6 fv-row" }
const _hoisted_75 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_76 = { class: "fv-plugins-message-container" }
const _hoisted_77 = { class: "fv-help-block" }
const _hoisted_78 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_79 = { class: "d-flex align-items-center fs-5 fw-bold mb-2" }
const _hoisted_80 = { class: "required" }
const _hoisted_81 = {
  disabled: "",
  selected: "",
  value: ""
}
const _hoisted_82 = ["value"]
const _hoisted_83 = { class: "fv-plugins-message-container" }
const _hoisted_84 = { class: "fv-help-block" }
const _hoisted_85 = {
  key: 0,
  class: "row mb-5"
}
const _hoisted_86 = { class: "col-md-6 fv-row" }
const _hoisted_87 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_88 = { class: "fv-plugins-message-container" }
const _hoisted_89 = { class: "fv-help-block" }
const _hoisted_90 = { class: "col-md-6 fv-row" }
const _hoisted_91 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_92 = { class: "fv-plugins-message-container" }
const _hoisted_93 = { class: "fv-help-block" }
const _hoisted_94 = { class: "row mb-5" }
const _hoisted_95 = { class: "col-md-6 fv-row" }
const _hoisted_96 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_97 = { class: "fv-plugins-message-container" }
const _hoisted_98 = { class: "fv-help-block" }
const _hoisted_99 = { class: "col-md-6 fv-row" }
const _hoisted_100 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_101 = { class: "fv-plugins-message-container" }
const _hoisted_102 = { class: "fv-help-block" }
const _hoisted_103 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_104 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_105 = { class: "modal-footer flex-center" }
const _hoisted_106 = {
  type: "reset",
  "data-bs-dismiss": "modal",
  id: "kt_modal_new_property_cancel",
  class: "btn btn-white me-3"
}
const _hoisted_107 = {
  ref: "submitButtonRef",
  type: "submit",
  id: "kt_modal_new_property_submit",
  class: "btn btn-primary"
}
const _hoisted_108 = { class: "indicator-label" }
const _hoisted_109 = { class: "indicator-progress" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          class: "form",
          id: "kt_modal_new_property_form",
          onSubmit: _ctx.submit,
          "validation-schema": _ctx.validationSchema
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.translate('addNewProperty')), 1),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.translate('PACI Number')), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_Field, {
                      type: "number",
                      class: "form-control form-control-solid",
                      placeholder: _ctx.translate('paciNo'),
                      name: "paciNo",
                      modelValue: _ctx.property.paciNo,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.property.paciNo) = $event)),
                      onInput: _cache[1] || (_cache[1] = ($event: any) => (
                      _ctx.property.paciNo = $event.target.value
                        ? Number($event.target.value)
                        : null
                    ))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("button", {
                      type: "button",
                      id: "kt_account_profile_details_submit",
                      ref: "submitPullButton",
                      class: "btn btn-primary flex-shrink-0 p-2 m-2",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.pullData && _ctx.pullData(...args)))
                    }, [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.translate('pullData')), 1),
                      _createElementVNode("span", _hoisted_13, [
                        _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                        _hoisted_14
                      ])
                    ], 512)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_ErrorMessage, { name: "paciNo" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("label", _hoisted_19, [
                      _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.translate('propertyType')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.selectedPropertyType,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedPropertyType) = $event)),
                        required: true,
                        label: "title",
                        trackBy: "title",
                        searchable: true,
                        canDeselect: false,
                        options: _ctx.propertyTypes,
                        placeholder: _ctx.translate('selectPropertyType'),
                        valueProp: "id",
                        noResultsText: _ctx.translate('noResultsFound'),
                        name: "selectedPropertyType"
                      }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"]),
                      (_ctx.selectedPropertyType == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.translate('PROPERTY_TYPE_IS_REQUIRED_FIELD')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("label", _hoisted_25, [
                      _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.translate('area')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.selectedArea,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedArea) = $event)),
                        required: true,
                        label: "titleAr",
                        trackBy: "titleAr",
                        searchable: true,
                        canDeselect: false,
                        options: _ctx.areas,
                        placeholder: _ctx.translate('selectAreas'),
                        valueProp: "id",
                        noResultsText: _ctx.translate('noResultsFound'),
                        name: "selectedArea"
                      }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"]),
                      (_ctx.selectedArea == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.translate('AREA_IS_REQUIRED_FIELD')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("label", _hoisted_32, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate('auctionDescription')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.selectedAuctionDescription,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedAuctionDescription) = $event)),
                        label: "titleAr",
                        trackBy: "titleAr",
                        searchable: true,
                        canDeselect: false,
                        options: _ctx.auctionDescriptions,
                        placeholder: _ctx.translate('selectAuctionDescription'),
                        valueProp: "id",
                        noResultsText: _ctx.translate('noResultsFound'),
                        name: "selectedAuctionDescription"
                      }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"]),
                      (_ctx.selectedAuctionDescription == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("label", _hoisted_36, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate('auctionLocation')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.selectedAuctionLocation,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedAuctionLocation) = $event)),
                        label: "titleAr",
                        trackBy: "titleAr",
                        searchable: true,
                        canDeselect: false,
                        options: _ctx.auctionLocations,
                        placeholder: _ctx.translate('selectAuctionLocation'),
                        valueProp: "id",
                        noResultsText: _ctx.translate('noResultsFound'),
                        name: "selectedAuctionLocation"
                      }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"]),
                      (_ctx.selectedAuctionLocation == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.translate('block')), 1),
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid",
                      placeholder: _ctx.translate('propertyBlock'),
                      name: "block",
                      modelValue: _ctx.property.block,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.property.block) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _createVNode(_component_ErrorMessage, { name: "block" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.translate('plot')), 1),
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid",
                      placeholder: _ctx.translate('propertyPlot'),
                      name: "plot",
                      modelValue: _ctx.property.plot,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.property.plot) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createVNode(_component_ErrorMessage, { name: "plot" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.translate('startingPrice')), 1),
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid",
                      placeholder: _ctx.translate('startingPrice'),
                      name: "startingPrice",
                      onInput: _cache[9] || (_cache[9] = ($event: any) => {
                      _ctx.updateStartingPricePerSqrM();
                      _ctx.updatePercentagePremiumPaid();
                    }),
                      modelValue: _ctx.property.startingPrice,
                      "onUpdate:modelValue": [
                        _cache[10] || (_cache[10] = ($event: any) => ((_ctx.property.startingPrice) = $event)),
                        _ctx.onStartingPriceInput
                      ],
                      style: {"color":"red","font-weight":"bold"}
                    }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"]),
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _createVNode(_component_ErrorMessage, { name: "startingPrice" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.translate('supplyPercentage')), 1),
                    _createVNode(_component_Field, {
                      type: "number",
                      class: "form-control form-control-solid",
                      placeholder: _ctx.translate('supplyPercentage'),
                      name: "supplyPercentage",
                      modelValue: _ctx.property.supplyPercentage,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.property.supplyPercentage) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("div", _hoisted_55, [
                        _createVNode(_component_ErrorMessage, { name: "supplyPercentage" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.translate('size')), 1),
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid",
                      placeholder: _ctx.translate('propertySize'),
                      name: "size",
                      onInput: _cache[12] || (_cache[12] = ($event: any) => {
                      _ctx.updateStartingPricePerSqrM();
                      _ctx.updateSalePricePerSqm();
                    }),
                      modelValue: _ctx.property.size,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.property.size) = $event)),
                      style: {"color":"#0066ff","font-weight":"bold"}
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, [
                        _createVNode(_component_ErrorMessage, { name: "size" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("label", _hoisted_62, _toDisplayString(_ctx.translate('additionalInfoEn')), 1),
                    _createVNode(_component_Field, {
                      class: "form-control form-control-solid",
                      placeholder: _ctx.translate('additionalInfoInEn'),
                      name: "additionalInfoEn"
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("div", _hoisted_64, [
                        _createVNode(_component_ErrorMessage, { name: "additionalInfoEn" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("label", _hoisted_66, _toDisplayString(_ctx.translate('address')), 1),
                    _createVNode(_component_Field, {
                      class: "form-control form-control-solid",
                      placeholder: _ctx.translate('address'),
                      name: "address",
                      modelValue: _ctx.property.address,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.property.address) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        _createVNode(_component_ErrorMessage, { name: "address" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.translate('longitude')), 1),
                    _createVNode(_component_Field, {
                      type: "number",
                      class: "form-control form-control-solid",
                      placeholder: _ctx.translate('longitude'),
                      name: "longitude",
                      modelValue: _ctx.property.longitude,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.property.longitude) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("div", _hoisted_73, [
                        _createVNode(_component_ErrorMessage, { name: "longitude" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("label", _hoisted_75, _toDisplayString(_ctx.translate('latitude')), 1),
                    _createVNode(_component_Field, {
                      type: "number",
                      class: "form-control form-control-solid",
                      placeholder: _ctx.translate('latitude'),
                      name: "latitude",
                      modelValue: _ctx.property.latitude,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.property.latitude) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("div", _hoisted_77, [
                        _createVNode(_component_ErrorMessage, { name: "latitude" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_78, [
                  _createElementVNode("label", _hoisted_79, [
                    _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.translate('propertyStatus')), 1)
                  ]),
                  _createVNode(_component_Field, {
                    name: "statusId",
                    class: "form-select form-select-solid",
                    as: "select",
                    modelValue: _ctx.statusId,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.statusId) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("option", _hoisted_81, _toDisplayString(_ctx.translate('selectStatus')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (status) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: status.id,
                          value: status.id
                        }, _toDisplayString(status.title), 9, _hoisted_82))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_83, [
                    _createElementVNode("div", _hoisted_84, [
                      _createVNode(_component_ErrorMessage, { name: "statusId" })
                    ])
                  ])
                ]),
                (_ctx.statusId == 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                      _createElementVNode("div", _hoisted_86, [
                        _createElementVNode("label", _hoisted_87, _toDisplayString(_ctx.translate('salePrice')), 1),
                        _createVNode(_component_Field, {
                          type: "text",
                          class: "form-control form-control-solid",
                          placeholder: _ctx.translate('salePrice'),
                          name: "salePrice",
                          onInput: _cache[18] || (_cache[18] = ($event: any) => {
                      _ctx.updateSalePricePerSqm();
                      _ctx.updatePercentagePremiumPaid();
                    }),
                          modelValue: _ctx.property.salePrice,
                          "onUpdate:modelValue": [
                            _cache[19] || (_cache[19] = ($event: any) => ((_ctx.property.salePrice) = $event)),
                            _ctx.onSalePriceInput
                          ]
                        }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"]),
                        _createElementVNode("div", _hoisted_88, [
                          _createElementVNode("div", _hoisted_89, [
                            _createVNode(_component_ErrorMessage, { name: "salePrice" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_90, [
                        _createElementVNode("label", _hoisted_91, _toDisplayString(_ctx.translate('salePricePerSqm')), 1),
                        _createVNode(_component_Field, {
                          type: "text",
                          class: "form-control form-control-solid",
                          placeholder: _ctx.translate('salePricePerSquareMeter'),
                          name: "salePricePerSqrM",
                          modelValue: _ctx.property.salePricePerSqrM,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.property.salePricePerSqrM) = $event))
                        }, null, 8, ["placeholder", "modelValue"]),
                        _createElementVNode("div", _hoisted_92, [
                          _createElementVNode("div", _hoisted_93, [
                            _createVNode(_component_ErrorMessage, { name: "salePricePerSqrM" })
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_94, [
                  _createElementVNode("div", _hoisted_95, [
                    _createElementVNode("label", _hoisted_96, _toDisplayString(_ctx.translate('startingPricePerSqm')), 1),
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid input-disabled",
                      placeholder: _ctx.translate('startingPricePerSquareMeter'),
                      name: "startingPricePerSqrM",
                      disabled: "true",
                      modelValue: _ctx.property.startingPricePerSqrM,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.property.startingPricePerSqrM) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_97, [
                      _createElementVNode("div", _hoisted_98, [
                        _createVNode(_component_ErrorMessage, { name: "startingPricePerSqrM" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_99, [
                    _createElementVNode("label", _hoisted_100, _toDisplayString(_ctx.translate('percentagePremiumPaid')), 1),
                    _createVNode(_component_Field, {
                      class: "form-control form-control-solid input-disabled",
                      placeholder: _ctx.translate('percentagePremiumPaid'),
                      name: "percentagePremiumPaid",
                      disabled: "true",
                      modelValue: _ctx.property.percentagePremiumPaid,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.property.percentagePremiumPaid) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_101, [
                      _createElementVNode("div", _hoisted_102, [
                        _createVNode(_component_ErrorMessage, { name: "percentagePremiumPaid" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_103, [
                  _createElementVNode("label", _hoisted_104, _toDisplayString(_ctx.translate('attachments')), 1),
                  (_ctx.showFileInput)
                    ? (_openBlock(), _createBlock(_component_Field, {
                        key: 0,
                        type: "file",
                        accept: ".pdf,application/pdf,.doc,.docx,.xlsx,.xls,.ppt,.pptx,application/msword,application/vnd.ms-excel,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.presentationml.slideshow,application/vnd.openxmlformats-officedocument.presentationml.presentation,.txt,text/plain,",
                        autocomplete: "off",
                        class: "form-control form-control-solid",
                        placeholder: _ctx.translate('propertyAttachments'),
                        name: "attachment"
                      }, null, 8, ["placeholder"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_105, [
              _createElementVNode("button", _hoisted_106, _toDisplayString(_ctx.translate('discard')), 1),
              _createElementVNode("button", _hoisted_107, [
                _createElementVNode("span", _hoisted_108, _toDisplayString(_ctx.translate('saveChanges')), 1),
                _createElementVNode("span", _hoisted_109, [
                  _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                  _hoisted_110
                ])
              ], 512)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ])
  ], 512))
}